import { NgcCarIdentifier } from '~/app/utils/graphql-sub-types';
import { ModelCatalogInput } from '~/graphql/__generated__/graphql';
import { DriveTrain } from '~/graphql/mapper';

export const createCarlineInput = (carline: NgcCarIdentifier, driveTrain: DriveTrain): ModelCatalogInput => {
	const modelId = driveTrain.__item.modelId;
	const extensions = modelId.extensions ? modelId.extensions.join('') : '';
	const modelCode = `${modelId.code}${modelId.version}${extensions}_${modelId.year}`;

	return {
		brand: carline.brand,
		country: carline.country,
		language: carline.language,
		model: modelCode,
	};
};
